import createVanilla from 'zustand/vanilla';
import zustandCreateBoundStore, { useStore as useStore$1 } from 'zustand';
import flow from 'lodash.flow';
import matchAll from 'string.prototype.matchall';
import * as React from 'react';
export { default as shallow } from 'zustand/shallow';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
    h = l ^ l,
    i = 0,
    k;
  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }
  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }
  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

matchAll.shim();
var LogLevel;
(function (LogLevel) {
  LogLevel["None"] = "none";
  LogLevel["Diff"] = "diff";
  LogLevel["All"] = "all";
})(LogLevel || (LogLevel = {}));
function getDeps(fn) {
  const reg = new RegExp(/(?:this\.)(\w+)/g);
  const reg2 = new RegExp(/(?:this\[')(\w+)(?:'\])/g);
  const matches = Array.from(fn.toString().matchAll(reg)).map(match => match[1]);
  const matches2 = Array.from(fn.toString().matchAll(reg2)).map(match => match[1]);
  const mergedMatches = Array.from(new Set([...matches, ...matches2]));
  return mergedMatches;
}
function intersection(aArray, bArray) {
  let intersections = [];
  for (let elem of bArray) {
    if (aArray.includes(elem)) {
      intersections.push(elem);
    }
  }
  return intersections;
}
function createKey(stateInitializer, name) {
  //@ts-expect-error
  const state = stateInitializer();
  const {
    initialState,
    actions
  } = Object.keys(state).reduce((acc, key) => {
    let actions = acc['actions'];
    let initialState = acc['initialState'];
    if (typeof state[key] === 'function') {
      actions = _extends({}, actions, {
        [key]: state[key]
      });
    } else {
      initialState = _extends({}, initialState, {
        [key]: state[key]
      });
    }
    return {
      initialState,
      actions
    };
  }, {
    initialState: {},
    actions: {}
  });
  const src = !name ? Object.keys(actions).reduce((acc, k) => acc + actions[k].toString(), '') : '';
  return [name, murmurhash2_32_gc(src + JSON.stringify(initialState))].filter(Boolean);
}
function createArchieStoreCreator({
  name = '',
  stateInitializer,
  addons = {}
}) {
  let key;
  return {
    get key() {
      // FIXME: the key is confusing since this is the store vs the registry key
      // lazy evaluate key on first access
      return key || (key = createKey(stateInitializer, name));
    },
    name,
    stateInitializer,
    addons
  };
}
function createArchieStoreApi(storeCreator) {
  var _addons$settings$logL, _addons$settings, _addons$computed, _addons$watchers;
  const {
    key,
    stateInitializer,
    addons = {}
  } = storeCreator;
  let _api;
  let _originalSetState;
  let _computed = {};
  let updatedComputed = {};
  let _computedMerged = false;
  let _computedPropDependencies = {};
  let _watchers = {};
  let _settings = {
    name: key.join('__'),
    logLevel: (_addons$settings$logL = addons == null ? void 0 : (_addons$settings = addons.settings) == null ? void 0 : _addons$settings.logLevel) != null ? _addons$settings$logL : LogLevel.None
  };
  function attachMiddleWare(config) {
    return (set, get, api) => {
      // Overwrites set method
      return config(
      // @ts-expect-error
      (args, setSettings) => {
        return setMiddleware([args, setSettings], set);
      }, get, api);
    };
  }
  // Overwrites setState method
  function setState(args, setSettings) {
    setMiddleware([args, setSettings], _originalSetState);
  }
  function setMiddleware(args, set, recursiveOp = false) {
    var _excludeFromLogs;
    const [partialState, setSettings] = args;
    let replaceState = false;
    let excludeFromLogs = false;
    if (typeof setSettings !== 'undefined') {
      if (typeof setSettings === 'boolean') {
        replaceState = setSettings;
      } else if (typeof setSettings === 'object') {
        replaceState = setSettings.replace || false;
        excludeFromLogs = setSettings.excludeFromLogs || false;
      }
    }
    let logOperations = ((_excludeFromLogs = !excludeFromLogs) != null ? _excludeFromLogs : true) && _computedMerged && _settings.logLevel !== LogLevel.None;
    const currentState = _api.getState();
    const changes = typeof partialState === 'function' ? partialState(currentState) : partialState;
    const group = `${_settings.name} state changed`;
    logOperations && !recursiveOp && console.group(group);
    logOperations && !recursiveOp && _settings.logLevel === LogLevel.All && console.log('Previous State', currentState);
    logOperations && !recursiveOp && console.log('Applying', changes);
    updatedComputed = {};
    if (!replaceState) {
      for (const [compPropName, compPropDeps] of Object.entries(_computedPropDependencies)) {
        const needsRecompute = intersection(Object.keys(changes), compPropDeps);
        if (needsRecompute.length > 0) {
          updatedComputed[compPropName] = _computed[compPropName].apply(_extends({}, currentState, changes, updatedComputed), [{
            set: _api.setState,
            get: _api.getState
          }]);
        }
      }
    }
    if (Object.keys(updatedComputed).length > 0) {
      logOperations && console.log('Updating computed values', updatedComputed);
    }
    const newState = _extends({}, changes, updatedComputed);
    // Clean computed properties and watchers if they are no longer in the state
    if (replaceState) {
      for (const [compPropName] of Object.entries(_computed)) {
        if (!(compPropName in newState)) {
          delete _computed[compPropName];
          delete _computedPropDependencies[compPropName];
        }
      }
      for (const [watcherName] of Object.entries(_watchers)) {
        if (!(watcherName in newState)) {
          delete _watchers[watcherName];
        }
      }
    }
    set(newState, replaceState);
    for (const [propName, fn] of Object.entries(_watchers)) {
      if (Object.keys(newState).includes(propName)) {
        logOperations && console.log(`Triggering watcher: ${propName}`);
        fn.apply({
          set: _api.setState,
          get: _api.getState,
          api: _api
        }, [newState[propName], currentState[propName]]);
      }
    }
    if (Object.keys(updatedComputed).length > 0 && !replaceState) {
      setMiddleware([updatedComputed, setSettings], _originalSetState, true);
    }
    logOperations && _settings.logLevel === LogLevel.All && !recursiveOp && console.log('New State', _api.getState());
    logOperations && !recursiveOp && console.groupEnd();
  }
  const middlewareFunctions = (middleware, store) => middleware ? flow(middleware)(store) : store;
  function configComputed(computed) {
    let computedToAdd = {};
    for (const [key, value] of Object.entries(computed)) {
      const deps = getDeps(value);
      if (deps.length > 0) {
        _computedPropDependencies[key] = deps;
        _computed[key] = value;
      }
      computedToAdd = _extends({}, computedToAdd, {
        [key]: value.apply(_extends({}, _api.getState(), computedToAdd), [{
          set: _api.setState,
          get: _api.getState
        }])
      });
    }
    if (Object.keys(computedToAdd).length > 0) {
      _api.setState(computedToAdd);
    }
    _computedMerged = true;
  }
  function configWatchers(watchers) {
    for (const [propName, fn] of Object.entries(watchers)) {
      _watchers[propName] = fn;
    }
  }
  function _stateCreator(set, get, api) {
    _api = api;
    // @ts-expect-error
    _originalSetState = _extends({}, api).setState;
    _api.setState = setState;
    return _extends({}, stateInitializer(set, get, api));
  }
  let store = createVanilla(
  // @ts-expect-error
  attachMiddleWare(middlewareFunctions(addons == null ? void 0 : addons.middleware, _stateCreator)));
  Object.assign(store, {
    key,
    __NAME__: storeCreator.name
  });
  configComputed((_addons$computed = addons == null ? void 0 : addons.computed) != null ? _addons$computed : {});
  configWatchers((_addons$watchers = addons == null ? void 0 : addons.watchers) != null ? _addons$watchers : {});
  // const stateHook: any = storeRegistry => (selector: any, equalityFn?: any) => {
  //   if (typeof selector === 'string') {
  //     if (selector.indexOf(',') !== -1) {
  //       const props = selector.split(',').map(part => part.trim());
  //       return hook(state => props.map(prop => state[prop]), shallow);
  //     }
  //     return hook(state => state[selector], equalityFn);
  //   }
  //   return hook(selector, equalityFn);
  // };
  return store;
}
const toSerializedDataProps = s => {
  return s.reduce((acc, store, index) => {
    if (!store.key) {
      throw new Error(`Store is missing a name. At index:, ${index}`);
    }
    const state = store.getState();
    // blacklist functions when serializing
    Object.keys(state).forEach(key => {
      if (typeof state[key] === 'function') delete state[key];
    });
    const strState = JSON.stringify(state);
    const version = murmurhash2_32_gc(strState);
    return _extends({}, acc, {
      [store.key.join('__')]: {
        state: strState,
        version
      }
    });
  }, {});
};
function createSSRStore(storeCreator, fn) {
  const api = createArchieStoreApi(storeCreator);
  fn == null ? void 0 : fn(api);
  return api;
}
const createSingletonStore = createState => zustandCreateBoundStore(createState);

const defaultScope = '__global__';
class StoreRegistry {
  constructor(scope = defaultScope) {
    this.storeMap = void 0;
    this.registryScope = defaultScope;
    this.generateKey = (store, scopeId = this.registryScope) => `${store.key.join('__')}@${scopeId}`;
    this.storeMap = new Map();
    this.registryScope = scope;
  }
  getEntry(storeCreator) {
    const key = this.generateKey(storeCreator);
    return this.storeMap.get(key);
  }
  getEntryByKey(key) {
    return this.storeMap.get(key);
  }
  initStoreApi(storeCreator, initialState = {}, version = '') {
    const registryKey = this.generateKey(storeCreator);
    const _store = createArchieStoreApi(storeCreator); //, FIXME: registryKey);
    _store.setState(_extends({}, _store.getState(), initialState));
    this.storeMap.set(registryKey, {
      store: _store,
      version
    });
    return _store;
  }
  hydrateStore(key, state = {}, version = '', csrHydrated = false) {
    var _this$storeMap$get;
    const _store = (_this$storeMap$get = this.storeMap.get(key)) == null ? void 0 : _this$storeMap$get.store;
    if (_store) {
      _store.setState(_extends({}, _store.getState(), state));
      this.storeMap.set(key, {
        store: _store,
        version,
        csrHydrated
      });
    }
  }
  getStore(storeCreator) {
    var _this$storeMap$get2;
    const registryKey = this.generateKey(storeCreator);
    return (_this$storeMap$get2 = this.storeMap.get(registryKey)) == null ? void 0 : _this$storeMap$get2.store;
  }
  removeStore(key) {
    var _this$storeMap$get3;
    (_this$storeMap$get3 = this.storeMap.get(key)) == null ? void 0 : _this$storeMap$get3.store.destroy();
    return this.storeMap.delete(key);
  }
  clear() {
    this.storeMap.forEach(value => value.store.destroy());
    this.storeMap.clear();
  }
}

const registryRef = {
  current: null
};
const StoreContext = React.createContext({
  registry: null,
  value: {}
});
const isSSR = typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const StoreProvider = ({
  value,
  children
}) => {
  // ALWAYS return a new registry for SSR so no sharing values
  if (!registryRef.current || isSSR) {
    registryRef.current = isSSR ? new StoreRegistry('__SSR__') : new StoreRegistry();
  }
  React.useEffect(() => {
    if (registryRef.current && value) {
      const currentStoreKeyValues = Array.from(registryRef.current.storeMap.keys());
      const incomingStoreKeyValues = Object.keys(value).map(k => {
        var _registryRef$current;
        return `${k}@${(_registryRef$current = registryRef.current) == null ? void 0 : _registryRef$current.registryScope}`;
      });
      // CLEAN UP OLD UNUSED STORES - this includes older `version`'s of the same store (based on key/version combo)
      let oldKeys = currentStoreKeyValues.filter(k => !incomingStoreKeyValues.includes(k));
      oldKeys.forEach(k => {
        var _registryRef$current2, _registryRef$current3;
        if (!((_registryRef$current2 = registryRef.current) != null && (_registryRef$current3 = _registryRef$current2.getEntryByKey(k)) != null && _registryRef$current3.csrHydrated)) {
          var _registryRef$current4;
          registryRef == null ? void 0 : (_registryRef$current4 = registryRef.current) == null ? void 0 : _registryRef$current4.removeStore(k);
        }
      });
      /*
       * ==============================
       * STORE HYDRATION
       * ---------------
       * Hydrate inside here not on the component useEffect hook level.
       * - Use the registry.
       * - Find the store using the key.
       * - Then hydrate the store here only if it exists.
       * - IF a store doesn't exist already we let the hook initialize it when it triggers as we need a reference to the `storeCreator` to do that.
       * ==============================
       */
      Object.keys(value).forEach(s => {
        var _registryRef$current5, _registryRef$current6;
        const key = `${s}@${(_registryRef$current5 = registryRef.current) == null ? void 0 : _registryRef$current5.registryScope}`;
        const {
          state,
          version
        } = value[s];
        const entry = (_registryRef$current6 = registryRef.current) == null ? void 0 : _registryRef$current6.getEntryByKey(key);
        if (entry != null && entry.store && (entry == null ? void 0 : entry.version) !== version) {
          var _registryRef$current7;
          (_registryRef$current7 = registryRef.current) == null ? void 0 : _registryRef$current7.hydrateStore(key, JSON.parse(state), version, true);
        }
      });
      // after we finish with all the mounting and store initialization we unset the flag so it gets cleaned
      // when we navigate
      for (let [, entry] of registryRef.current.storeMap.entries()) {
        entry.csrHydrated = false;
      }
    }
  }, [value]);
  return React.createElement(StoreContext.Provider, {
    value: {
      registry: registryRef.current,
      value
    }
  }, children);
};
const useStoreContext = () => {
  const {
    registry,
    value
  } = React.useContext(StoreContext);
  return {
    registry,
    value
  };
};
const _getOrCreateStoreFromRegistry = storeCreator => {
  var _contextValues$storeK, _entry;
  const {
    registry: contextRegistry,
    value: contextValues
  } = useStoreContext();
  if (!contextRegistry) throw new Error("Seems like you have not used a store provider as an ancestor. There's no registry to look up a store");
  // THE registry SCOPE WILL MESS THIS UP SO NEED TO FIGURE THIS OUT - the key isn't the registry key
  const storeKey = storeCreator.key.join('__');
  const {
    state,
    version
  } = (_contextValues$storeK = contextValues == null ? void 0 : contextValues[storeKey]) != null ? _contextValues$storeK : {};
  let entry = contextRegistry.getEntry(storeCreator);
  if ((_entry = entry) != null && _entry.store) {
    return entry.store;
  }
  // If the store doesn't exist we create it, then we hydrate it with initial data if any.
  const store = contextRegistry.initStoreApi(storeCreator);
  // Grab the entry again
  entry = contextRegistry.getEntry(storeCreator);
  // Hydrate the newly created store with `state`
  const values = JSON.parse(state != null ? state : '{}');
  contextRegistry.hydrateStore(`${storeKey}@${contextRegistry.registryScope}`, values, version, !isSSR);
  // We this should never happen unless we mess something up bad.
  if (!store) throw new Error(`No store was found!!, ${storeCreator.key}`);
  return store;
};
//@ts-expect-error
const useStore = (
// eslint-disable-line
storeCreator, selector, equalityFn = Object.is) => {
  const store = _getOrCreateStoreFromRegistry(storeCreator);
  return useStore$1(store, selector, equalityFn); // eslint-disable-line
};

const useStoreApi = storeCreator => {
  const _store = _getOrCreateStoreFromRegistry(storeCreator);
  return React.useMemo(() => ({
    __NAME__: storeCreator.name,
    key: storeCreator.key,
    getState: _store.getState,
    setState: _store.setState,
    subscribe: _store.subscribe,
    destroy: _store.destroy
  }), [storeCreator, _store]);
};
const createHook = storeCreator => {
  const useBoundStore = (selector, equalityFn) => useStore(storeCreator, selector, equalityFn);
  Object.assign(useBoundStore, {
    key: storeCreator.key,
    __NAME__: storeCreator.name
  });
  return useBoundStore;
};

export { LogLevel, StoreContext, StoreProvider, StoreRegistry, createArchieStoreApi, createArchieStoreCreator, createHook, createSSRStore, createSingletonStore, registryRef, toSerializedDataProps, useStore, useStoreApi, useStoreContext };
//# sourceMappingURL=index.esm.js.map
